<template>
	<div>
		<top-header></top-header>
		<div class="white-box">
			<navi></navi>
		</div>
		<div class="flex-box center-width mt30">
			<nav class="article-nav">
				<ul class="nav-list">
					<li v-for="(item, index) in navList" :key="index" :class="item.className" @click="toggleArticleType(item.type)">{{item.name}}</li>
				</ul>
			</nav>
			<div class="article-box">
		    <div class="header">{{titleName}}</div>
		    <div class="article-content">
		    	<section v-show="navList[0].isShow">
		    		<p>本协议的双方为“上海商晟通云网络科技有限公司”（下称“本平台”）与“您”（下称“用户”），协议内容包括以下条款及所有本平台已经发布的或将来可能发布的其他内容。所有在平台上发布的内容均为本协议不可分割的组成部分，与本协议具有同等法律效力。</p>
						<p>请您在注册、登录、使用本平台前认真阅读本协议，并充分理解本协议内容。一旦您在本平台上进行注册、登录、使用等操作，即视为您已同意本协议内容，如您违反本协议及相关法律法规的，您须自行承担相应的法律责任。</p>
						<p>本平台会根据需要不定期地制订、修改本协议及/或各类规则，并在本平台上公布，变更后的协议/规则一经公布，立即生效。如您不同意相关变更，请立即停止使用本平台的服务。如继续使用，视为您接受修订后的协议/规则。</p>
						<p class="paragraph">一、用户</p>
						<p>1.1用户应为具有完全民事权利能力和民事行为能力的自然人、法人或其他组织，能够独立承担法律责任。若不具备前述规定的法律能力，须经法定代理人同意或由法定代理人代理，或是得到有权主体授权后进行注册、交易。</p>
						<p>1.2如您不具备用户资格，请停止注册、登录、使用等操作，否则本平台有权随时中止或终止您的用户资格。</p>
						<p>1.3用户须向本平台提供注册资料，并保证提供的注册资料真实、准确、完整、合法、有效；如有变动的，应及时更新其注册资料。如您提供的注册资料不真实、不准确、不完整、不合法的，您需承担相应的法律责任及后果，且本平台有权终止向您提供本平台的各项服务。</p>
						<p>1.4用户在本平台进行浏览、发布信息、下单订购等操作时，涉及用户真实姓名、名称、通信地址、联系电话等隐私信息的，本平台将予以严格保密，除非得到用户授权、法律另有规定及相关监管部门要求，本平台不会向外界披露用户隐私信息。</p>
						<p>1.5您注册成功后，本平台将生成相应的用户名和密码等账户信息，您可根据本平台规定更改账户密码。您应妥善保管用户名和密码，如因您设置不当、主动/被动泄露、遭受他人攻击、诈骗等行为造成损失，请通过司法、行政救济途径解决，本平台不承担任何责任。</p>
						<p>1.6用户的用户名和密码等账户信息不得以任何方式转让、赠与、出借或继承（与账户相关的财产权益除外），否则由将您及实际使用人承担一切法律责任和后果，我方不承担任何责任。</p>
						<p>1.7本平台有权以邮件、短信、电话的方式，向您发送相应的平台信息（包括但不限于订单信息、促销信息等）。
						<p>1.8 用户知晓并同意平台方为任何目的保存的与用户在平台操作的记录（包括通话记录或电子指令）对用户是有约束力且为最终确定的，并且是用户和平台方之间传输的信息或数据的决定性且内容不容辩驳的证据。用户在此同意所有的记录均可作为证据使用，用户不能仅仅因为该记录采用电子形式或通过计算机系统输出而对该记录作为证据的合理性、可靠性、准确性和真实性进行质疑，用户放弃质疑的权利。</p>
						<p class="paragraph">二、内容规范</p>
						<p>2.1不得传输或发表煽动抗拒、破坏宪法和法律、行政法规实施言论，煽动颠覆国家政权，推翻社会主义制度言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论。</p>
						<p>2.2用户向境外传输资料信息时必须符合中国有关法律法规的规定。</p>
						<p>2.3不得利用本平台从事洗钱、窃取商业机密、窃取个人信息等违法犯罪活动。</p>
						<p>2.4不得干扰本平台的正常运转，不得侵入本平台，不得侵犯其它用户或第三方合法权益。</p>
						<p>2.5不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、不文明的信息资料。</p>
						<p>2.6不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；</p>
						<p>若用户未遵守以上规定的，本平台有权做出独立判断并采取暂停或关闭用户账号等措施；同时，用户须对其言论和行为承担法律责任。</p>
						<p class="paragraph">三、所有权及知识产权声明</p>
						<p>3.1 用户一旦接受本协议，即表明该用户主动将其在任何时间段在本平台发表的任何形式的信息内容（包括但不限于信息发布、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，全部独家且不可撤销的转让给本平台所有，用户同意本平台有权就任何主题侵权而单独提起诉讼。</p>
						<p>3.2 本协议已经构成相关法律规定的著作财产权等权利转让书面协议，其效力基于用户在本平台上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。</p>
						<p>3.3 用户同意并已充分了解本协议的条款，承诺不将已发表于本平台的信息，以任何形式发布或授权其它主体以任何方式使用（包括但不限于在各类网站、媒体上使用）。</p>
						<p>3.4除法律另有强制性规定外，未经本平台明确的书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本平台的信息内容，否则，本平台有权追究其法律责任。</p>
						<p>3.5本平台所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是本平台或其内容提供者的财产，受中国和国际版权法的保护。本平台上所有内容的汇编是本平台的排他财产，受中国和国际版权法的保护。本平台上所有的软件都是本平台或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。</p>
						<p class="paragraph">四、用户的权利及责任</p>
						<p>4.1 信息发布</p>
						<p>（1）用户有权通过本平台发布采购／供应信息，本平台将根据国家法律法规或政府部门的要求进行过滤，对不符合法律法规的信息将做删除或拒绝处理。用户对其发布信息的真实性或合法性自行承担全部责任，本平台不作任何明示或默示的声明或担保。</p>
						<p>（2）用户信息发生变更的，用户负责及时在本平台上进行更新，否则由用户自行承担由此产生的一切法律责任和损失。</p>
						<p>（3）用户可自行或委托本平台工作人员查找入驻本平台采购商／供应商发布的采购/供应信息，并与采购商/供应商协商、洽谈合作意向。</p>
						<p>4.2用户有权自行修改其所发布的信息资料。</p>
						<p>4.3为保障用户在使用本平台交易服务的有效性，用户应保证：</p>
						<p>（1）用户在本平台上发布的或向本平台工作人员提供的全部信息资料是真实、合法和准确的，未违反相关法律法规、政策文件、不侵犯他人的合法权益。</p>
						<p>（2）用户对其所发布的信息资料中所涉及的产品拥有合法的权利或授权，并且产品符合国家需要的各种关于资料、检验检疫、卫生等方面的标准和要求。</p>
						<p>（3）用户不以非法手段获取他人的保密信息；未经采购商/供应商允许，不对采购商/供应商的信息（包括但不限于银行卡，姓名，手机号码，地址）进行泄露、散布；不对用户自身的产品等作虚假或引人误解的宣传。</p>
						<p>（4）用户会妥善保管其用户名和密码，并承诺通过该用户名进行的一切操作均为用户行为，用户愿意承担一切法律责任。</p>
						<p>（5）用户在本平台发布供应的产品信息与最终交付的产品一致。</p>
						<p class="paragraph">五、不承诺担保及不可抗力免责事由</p>
						<p>5.1 除非另有明确的书面说明，本平台提供给用户的全部信息、内容、材料、产品（包括软件）和服务，均是在“按现状”和“按现有”的基础上提供的。</p>
						<p>5.2 除非另有明确的书面说明，本平台不对用户交易及其在本平台上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保。</p>
						<p>5.3 用户理解并确认，因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的，本平台无须承担任何责任。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。</p>
						<p>5.4用户理解并确认，本平台需要定期或不定期地对平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，本平台无须承担任何责任，但本平台应事先进行通告。 </p>
						<p class="paragraph">六、其他</p>
						<p>6.1 根据国家法律法规变化及平台运营需要，本公司有权对本协议条款不时地进行修改或根据本协议制定、修改各类具体规则并在本平台相关系统板块发布，一经发布即生效。</p>
						<p>6.2 用户可随时登录查阅最新协议，用户有义务不时关注并阅读最新版的协议及公告。若用户在本协议及具体规则内容公告变更后继续使用本服务的，表示用户已经充分阅读、理解并接受修改后的协议和具体规则内容；如用户不同意更新后的协议，用户应立即停止使用。</p>
						<p>6.3本平台对本协议拥有最终的解释权。本协议及本平台有关页面的相关名词可互相引用参照，如有不同理解，则以本协议条款为准。此外，若本协议的部分条款被认定为无效或者无法实施时，本协议中的其他条款仍然有效。</p>
						<p>6.4因用户使用本平台提供的服务所导致的一切争议或纠纷，双方应尽力友好协商解决；协商不成时，任何一方将争议提交上海商晟通云网络科技有限公司住所地人民法院提起诉讼解决。 </p>
		    	</section>
		    </div>
			</div>
		</div>
		<copyright></copyright>
	</div>
</template>

<script>
	import topHeader from '../../components/common/header.vue'
	import navi from '../../components/common/nav.vue'
	import copyright from '../../components/common/copyright.vue'

	export default {
		data() {
		  return {
		  	titleName:'免责声明',
		  	type:'1',
		  	//文章详情
		  	navList:[
		  		{name:'平台注册协议',type:'1',isShow:false,className:''},
		  	]
		  };
		},
		created(){
			this.handleUrlParam();
		},
		mounted(){
		},
		methods: {
			toggleArticleType(type){//左边导航栏点击切换
				var vm = this;
				vm.navList.forEach(function(e){
					if(e.type===type){
						e.className = 'active';
						e.isShow = true;
						vm.titleName = e.name;
						document.title = e.name;
						history.pushState(null,document.title,location.href.split("?")[0]+"?type="+e.type);
					}else {
						e.className = '';
						e.isShow = false;
					}
				})
			},
			handleUrlParam(){//url带有type时处理
				var vm = this;
				if(vm.urlParam.getUrlKey('type')){
					vm.type = vm.urlParam.getUrlKey('type');
					console.log(vm.type);
					vm.toggleArticleType(vm.type);
				}else {//直接打开时
					vm.toggleArticleType(vm.type);
				}
			},
		},
		components:{
			topHeader,
			navi,
			copyright
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import '../../assets/css/reset.css'
  @import '../../assets/css/common.css'
  @import '../../assets/css/stylus/article.styl'
  [v-cloak] {
    display: none;
  }
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
	.article-box {
		background-image: url(../../assets/images/icons/labeling.png);
		background-repeat: no-repeat;
		background-position: left top;
		background-size: 56px 56px;
		font-size: 14px;
		color: #323232;
		line-height: 26px;
		.header {
			text-align: center;
			line-height: 77px;
			font-size: 28px;
			font-weight: bold;
			color: #323232;
			border-bottom: 1px solid #f0f0f0;
		}
		.article-content {
			line-height: 28px;
			font-size: 16px;
			padding: 20px 0;
			color: #646464;
			p {
				text-indent: 2em;
			}
			.paragraph {
				color: #333;
				margin-top: 20px;
				font-weight: bold;
				text-indent: inherit;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// webTerms.vue?16a2aa7e